import howlingWolf from '../assets/HowlingWolf.svg';

interface HowlingWolfProps {
  text?: string;
}
const HowlingWolf = ({ text }: HowlingWolfProps) => {
  return (
    <div className='flex flex-col items-center justify-center'>
      <img src={howlingWolf} alt='Howling Wolf' className='w-28 opacity-50' />
      {text && <h2 className='flex justify-center mb-2'>{text}</h2>}
    </div>
  );
};

export default HowlingWolf;
